import { Alert, type AlertColor, Snackbar } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

interface NotificationProps {
    show: boolean;
    message: string;
    duration?: number;
    severity?: AlertColor;
}

export function useNotification(timeout = 3000) {
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState<AlertColor>('success');

    useEffect(() => {
        if (show) {
            setTimeout(() => setShow(false), timeout);
        }
    }, [show, timeout]);

    const notify = useCallback((msg: string, severity?: AlertColor): void => {
        setMessage(msg);
        setShow(true);
        if (severity) {
            setSeverity(severity);
        }
    }, []);

    return { show, message, notify, severity };
}

export const Notification = ({ duration = 3000, message, severity = 'info', show }: NotificationProps) => {
    return (
        <Snackbar
            open={show}
            message={message}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={duration}
        >
            <Alert severity={severity}>{message}</Alert>
        </Snackbar>
    );
};
